import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type UserLocation = {
  country: string | null;
  state: string | null;
  zipCode: string | null;
  city: string | null;
};

export type UserLocationState = UserLocation & {
  status: 'pending' | 'resolved';
};

export const userLocationInitialState: UserLocationState = {
  country: null,
  state: null,
  zipCode: null,
  city: null,
  status: 'pending',
};

export const userLocationSlice = createSlice({
  name: 'UserLocation',
  initialState: userLocationInitialState,
  reducers: {
    setUserLocation: (writeableState, action: PayloadAction<UserLocation>) => {
      const {
        country = null,
        state = null,
        zipCode = null,
        city = null,
      } = action.payload;

      writeableState.country = country;
      writeableState.state = state;
      writeableState.zipCode = zipCode;
      writeableState.city = city;
      writeableState.status = 'resolved';
    },

    resetUserLocation: () => {
      return userLocationInitialState;
    },
  },
  selectors: {
    selectUserLocation: (sliceState) => sliceState,
  },
});

export const { setUserLocation, resetUserLocation } = userLocationSlice.actions;
export const { selectUserLocation } = userLocationSlice.selectors;

export default userLocationSlice.reducer;
export type UserLocationSlice = typeof userLocationSlice;
